"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGPGenerator = void 0;
const CGPProgram_1 = require("./CGPProgram");
class CGPGenerator {
    constructor(config) {
        this.config = config;
    }
    generate() {
        const middleNodes = Array.from({ length: this.config.numMiddleNodes }, (_, i) => this.generateMiddleNode(i));
        const outputs = Array.from({ length: this.config.numOutputs }, (_, i) => this.generateOutputNode(i));
        return {
            middleNodes,
            outputs,
        };
    }
    generateMiddleNode(middleNodeIdx) {
        const inputIndexes = Array.from({ length: this.config.nodeInputCount }, (_, i) => (0, CGPProgram_1.asNodeIndex)(Math.floor(Math.random() * 10000)));
        const operator = (0, CGPProgram_1.asOpIndex)(Math.floor(Math.random() * 10000));
        return {
            inputIndexes,
            operator,
        };
    }
    generateOutputNode(outputNodeIdx) {
        const leftInput = (0, CGPProgram_1.asNodeIndex)(Math.floor(Math.random() * 10000));
        return leftInput;
    }
}
exports.CGPGenerator = CGPGenerator;
